import { ASSISTANT_TYPES } from '../../../constants';
import sendRequest from '../../../service/sendRequest';
import callApi from '../../../service/callApi';

export const assistantStrategy = {
  supports: (assistant) => {
    return assistant.type === ASSISTANT_TYPES.FILE || assistant.type === ASSISTANT_TYPES.TEXT;
  },

  init: async (assistant, message) => {
    const response = await sendRequest(
      () => callApi.post(`/api/ai/playground/open-ai/assistant?assistantId=${assistant.value}`, message),
      {
        onError: (e) => {
          throw e;
        },
      },
    );

    return {
      threadId: response.data.threadId,
      response: response.data.response,
    };
  },

  reply: async (assistant, reply, threadId) => {
    const response = await sendRequest(
      () =>
        callApi.post(
          `/api/ai/playground/open-ai/assistant/reply?threadId=${threadId}&assistantId=${assistant.value}`,
          reply,
        ),
      {
        onError: (e) => {
          throw e;
        },
      },
    );

    return response.data;
  },

  reset: async (_, threadId) => {
    const response = await sendRequest(() => callApi.post(`/api/ai/playground/open-ai/reset?threadId=${threadId}`), {
      onError: (e) => {
        throw e;
      },
    });

    return response.data;
  },
};
